import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './shared/layout/main/main.component';
import {LayoutModule} from './shared/layout/layout.module';
import {OutwardChecksComponent} from './modules/outward-checks/outward-checks.component';
import {AuthGuardService} from './core/auth-guard/auth-guard.service';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ModulesComponent} from './modules/modules/modules.component';
import {CalendarComponent} from './calendar/calendar.component';
import {ArchiveComponent} from './archive/archive.component';
import {HelpComponent} from './help/help.component';
import {RedirectComponent} from './core/redirect/redirect.component';
import {ConfigurationsComponent} from './configurations/configurations.component';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        children:
            [
                {
                    path: 'modules',
                    component: ModulesComponent,
                    data: {breadcrumbs: ['Modules']}
                },
                {
                    path: 'modules/checksManagement',
                    component: OutwardChecksComponent,
                    data: {breadcrumbs: ['Modules', 'Checks Management']}
                },
                {
                    path: 'dashboard',
                    component: DashboardComponent,
                    data: {breadcrumbs: ['Dashboard']}
                },
                {path: 'calendar', component: CalendarComponent, data: {breadcrumbs: ['Calender']}},
                {path: 'archive', component: ArchiveComponent, data: {breadcrumbs: ['Archive']}},
                {path: 'help', component: HelpComponent, data: {breadcrumbs: ['Help']}},
                {path: 'config', component: ConfigurationsComponent, data: {breadcrumbs: ['configurations']}},
                {path: '**', redirectTo: 'redirect', pathMatch: 'full'},
                {path: 'redirect', component: RedirectComponent}

            ]
        // , canActivate: [AuthGuardService]
    },
    {path: '**', redirectTo: '', pathMatch: 'full'}
];

@NgModule({
    imports: [LayoutModule, RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
